// src/pages/maintenance/MaintenanceScanPage.js
// Landing page opened when a printed asset QR label is scanned (FRONTEND_URL/maintenance/scan/:qrCodeKey)
// or when a code is typed in manually. See docs/MAINTENANCE_MODULE.md.
import React, { useEffect, useState, useCallback } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import maintenanceService from '../../services/maintenanceService';
import MaintenanceNav from '../../components/MaintenanceNav';

const labelize = (s) => (s || '').replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());

export default function MaintenanceScanPage() {
  const { qrCodeKey } = useParams();
  const navigate = useNavigate();
  const [manualCode, setManualCode] = useState('');
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const resolve = useCallback(async (code) => {
    setLoading(true); setError(''); setResult(null);
    try {
      const data = await maintenanceService.scanQrCode(code);
      setResult(data);
    } catch (err) {
      setError(err?.response?.data?.message || 'No asset found for that code.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { if (qrCodeKey) resolve(qrCodeKey); }, [qrCodeKey, resolve]);

  return (
    <>
      <MaintenanceNav />
      <div className="container-fluid py-3" style={{ maxWidth: 700 }}>
      <Link to="/maintenance/assets" className="text-muted" style={{ fontSize: 13 }}>&larr; All Assets</Link>
      <h4 className="mb-3 mt-1">Scan Asset QR Code</h4>

      {!qrCodeKey && (
        <div className="input-group mb-3" style={{ maxWidth: 420 }}>
          <input
            className="form-control"
            placeholder="Paste or type QR code value"
            value={manualCode}
            onChange={e => setManualCode(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && manualCode.trim() && resolve(manualCode.trim())}
          />
          <button className="btn btn-primary" disabled={!manualCode.trim()} onClick={() => resolve(manualCode.trim())}>Look Up</button>
        </div>
      )}

      {loading && <div className="text-muted">Looking up asset…</div>}
      {error && <div className="alert alert-danger py-2" style={{ fontSize: 13 }}>{error}</div>}

      {result && (
        <div className="card">
          <div className="card-body">
            <h5>{result.asset.name}</h5>
            <p className="text-muted mb-2" style={{ fontSize: 13 }}>
              {labelize(result.asset.category)} {result.asset.Location?.name ? `· ${result.asset.Location.name}` : ''}
            </p>
            <div className="d-flex gap-2 mb-3">
              <Link to={`/maintenance/assets/${result.asset.id}`} className="btn btn-sm btn-outline-primary">View Asset</Link>
              <Link to={`/maintenance/work-orders?assetId=${result.asset.id}`} className="btn btn-sm btn-primary">Report an Issue</Link>
            </div>
            <h6>Recent Work Orders</h6>
            {result.recentWorkOrders?.length ? (
              <table className="table table-sm table-hover">
                <tbody>
                  {result.recentWorkOrders.map(wo => (
                    <tr key={wo.id} style={{ cursor: 'pointer' }} onClick={() => navigate(`/maintenance/work-orders/${wo.id}`)}>
                      <td style={{ fontSize: 13 }}>{wo.woNumber}</td>
                      <td style={{ fontSize: 13 }}>{wo.title}</td>
                      <td style={{ fontSize: 13 }}>{labelize(wo.status)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : <p className="text-muted" style={{ fontSize: 13 }}>No work orders yet.</p>}
          </div>
        </div>
      )}
      </div>
    </>
  );
}
